// One place for every found-stock react-query key. Producers and invalidators sit in four
// different files (the page, the drawer, the Locations hub button, the cycle-counts resolve
// handler), so a literal typed twice is a cache that silently stops invalidating.
//
// Called with the trailing argument omitted, `queue` and `declaration` yield the warehouse-wide
// PREFIX — what an invalidation or a cross-cutting refetch wants; called with it, the exact key one
// reader lives under.
export const foundStockQueryKeys = {
  queue: (warehouseId, params) => ['found_stock_queue', warehouseId, ...(params === undefined ? [] : [params])],
  awaiting: warehouseId => ['found_stock_awaiting', warehouseId],
  queueTotal: warehouseId => ['found_stock_queue_total', warehouseId],
  declaration: (warehouseId, declarationId) => ['found_stock_declaration', warehouseId, ...(declarationId == null ? [] : [declarationId])],
  product: productId => ['found_stock_product', productId],
}
